import {PaginationParams} from "./../../helpers/api";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {AxiosPromise, AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {LocationEntryModel, NewLocationEntryModel} from "../models/location";
import {HttpErrorModel} from "../../common/models/httpError";

export class LocationService {
    private static baseUrl = apiUrls.topology.locations;

    public static async getAll(paginationParams: PaginationParams): Promise<AxiosResponse<PageableModel<LocationEntryModel>>> {
        return await http.get<PageableModel<LocationEntryModel>>(Api.addPaginationParams(Api.getUrl(this.baseUrl), paginationParams));
    }

    public static async getLocation(id: string): Promise<AxiosResponse<LocationEntryModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${id}`);
    }

    public static async addLocation(data: NewLocationEntryModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.baseUrl), data);
    }

    public static async modifyLocation(data: NewLocationEntryModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/${id}`, data);
    }

    public static async removeLocation(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.baseUrl)}/${id}`);
    }
}
